import Vue from 'vue'
import store from '@/store'
import jwt from '@/helpers/jwtHelper'

const Environments = Object.freeze({
  Production: 'production',
  Staging: 'staging',
  Development: 'development',
})

const init = async () => {
  Vue.config.errorHandler = (err, vm, info) => {
    if ([Environments.Staging, Environments.Development].includes(process.env.NODE_ENV)) {
      // eslint-disable-next-line no-console
      console.log(err, vm, info)
    }
    if (window.newrelic && 'noticeError' in window.newrelic) {
      window.newrelic.noticeError(err, { component: vm.$options.name, info })
    }
  }

  const jwtIni = await jwt.initialize({
    async payload(data) {
      await store.dispatch('dashboard/updateContext', {
        user: data.user || {},
        tenant: data.tenant || {},
      })
    },

    async expired(data) {
      await store.dispatch('dashboard/updateContext', {
        user: false,
        tenant: false,
      })
      if (data.tenant) {
        window.location = data.tenant.return_url || 'https://eadbox.com'
      }
    },

    async missing() {
      await store.dispatch('dashboard/updateContext', {
        user: false,
        tenant: false,
      })
    },

    async error() {
      setTimeout(() => window.location.reload(), 2000)
    },
  })

  async function isAuthenticated() {
    if (!jwtIni) {
      await store.commit('ui/setError', { resource: 'jwt', code: 403 })
    }
  }
  await isAuthenticated()
}

export default {
  init,
}
